import './font.css'
import { createMuiTheme } from '@material-ui/core/styles';

export default createMuiTheme({
  palette: {
    primary: {
      light: '#d2e5fc',
      main: '#4874B2',
      dark: '#00204D',
      success: '#4CAF50',
      fail: '#F44336',
      danger: '#ffc107'
    },
    fontColor: {
      primary: 'rgba(0, 0, 0, 0.87)',
      secondary: 'rgba(0, 0, 0, 0.54)',
    }
  },
  typography: {
    fontFamily: "Roboto, sans-serif",
    h1: {
      fontWeight: 300,
      fontSize: '96px',
      lineHeight: '112px',
      letterSpacing: '-1.5px'
    },
    h2: {
      fontWeight: 300,
      fontSize: '60px',
      lineHeight: '120%',
      letterSpacing: '-0.5px'
    },
    h3: {
      fontSize: '48px',
      lineHeight: '116.7%'
    },
    h4: {
      fontsize: '34px',
      lineHeight: '123.5%',
      letterspacing: '0.25px'
    },
    h5: {
      fontSize: '24px',
      lineHeight: '133.4%'
    },
    h6: {
      fontSize: '20px',
      letterSpacing: '0.15px',
      lineHeight: '160%',
    },
    body1: {
      fontWeight: 400,
      fontSize: '16px',
      letterSpacing: '0.15px',
      lineHeight: '150%'
    },
    body2: {
      fontWeight: 400,
      fontSize: '14px',
      letterSpacing: '0.15px',
      lineHeight: '143%'
    },
    subtitle1: {
      fontSize: '16px',
      letterSpacing: '0.15px',
      lineHeight: '175%'
    },
    subtitle2: {
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '133.4%',
      letterSpacing: '0.1px',
    }
  }
});